import { CmsApiEmailCampaignSignupSingleBlockData } from 'modules/cms/api/types/blocks/CmsApiEmailCampaignSignupSingleBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpEmailCampaignSignupSingleBlock } from './CmsAmpEmailCampaignSignupSingleBlock';
import { CmsEmailCampaignSignupSingleBlock } from './CmsEmailCampaignSignupSingleBlock';

export const CmsEmailCampaignSignupSingleBlockMapping: CmsBlockMapping<CmsApiEmailCampaignSignupSingleBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Email Campaign Signup Single',
      },
      {
        prop: 'buttonText',
        msg: 'Button Text required for Email Campaign Signup Single',
      },
      {
        prop: 'campaignId',
        msg: 'Campaign ID required for Email Campaign Signup Single',
      },
      {
        prop: 'listId',
        msg: 'List ID required for Email Campaign Signup Single',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsEmailCampaignSignupSingleBlock,
    AmpComponent: CmsAmpEmailCampaignSignupSingleBlock,
  };
